import startCase from "lodash/startCase";

// Identifier labels come from a small, bounded catalogue (field / attribute
// names) but `toSentenceCaseLabel` is called in hot paths — per-row cell
// renderers and per-keystroke search filters. Cache results so a given
// identifier is `startCase`-d at most once for the life of the page.
const cache = new Map<string, string>();
const IDENTIFIER_LABEL_PATTERN = /^[A-Za-z0-9_]+$/;

/** Converts camelCase or snake_case labels like `sourceUpdatedAt` /
 *  `gl_account` to display names like `Source updated at` / `Gl account`.
 *  Strings that already contain whitespace or punctuation are returned unchanged. */
export const toSentenceCaseLabel = (value: string): string => {
  const cached = cache.get(value);
  if (cached !== undefined) return cached;

  const trimmed = value.trim();
  if (!trimmed || /\s/.test(trimmed) || !IDENTIFIER_LABEL_PATTERN.test(trimmed)) {
    cache.set(value, trimmed);
    return trimmed;
  }

  const title = startCase(trimmed);
  const label = title.charAt(0) + title.slice(1).toLowerCase();
  cache.set(value, label);
  return label;
};
